import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";
import { getMediaUrl } from '../../helper/mediaUrl';

const truncateWords = (text, wordLimit) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : text;
};

export default function BlogRelated({ initialData }) {
  const { blog_slug } = useParams();
  const [recentData, setRecentData] = useState(initialData || []);

  const fetchRecent = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, { method: "GET" });
      const result = await response.json();
      if (!result.blogs || result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      let latestBlogs = result.blogs.filter(
        (item) => item.slug?.toLowerCase() !== blog_slug?.toLowerCase()
      );
      if (latestBlogs.length === 0) { latestBlogs = result.blogs; }
      latestBlogs = latestBlogs.slice(0, 3);
      console.log("Final Blogs:", latestBlogs);
      setRecentData(latestBlogs);
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };
  useEffect(() => {
    fetchRecent();
  }, [blog_slug]);

  return (
    <section className="related-blog">
      <div className="container">
        <div className="row justify-content-end">
          <div className="col-lg-12">
            <h4 className="heading center-heading">Other Related Articles</h4>
          </div>
          <div className="col-lg-12">
            <div className="blog-slider row">
              {recentData.length === 0 ? (
                <p className="recent-data"> No related articles found  </p>) : (
                recentData.slice(0,3).map((item, index) => (
                  <div className="col-md-4 related-col" key={index}>
                    <div className="blogpost-box">
                      <Link to={`/blog/${item.slug}`}>
                        <picture>
                          <img src={getMediaUrl(item?.thumbnail)} className="img-responsive" alt={item?.alt_thumbnail} loading="lazy" />
                        </picture>
                        <div className="date-wrap">   
                          <span>{`${Math.max(1, Math.round((item?.description1?.length || 0) / 200))} Min `}</span>  
                          <span>{DateConvert(item?.date)}</span>  
                        </div>
                        <p>{truncateWords(item?.title, 13)}</p>
                        <div className="arrow-butn">Read More <img src="/image/right-arrow.svg" alt="arrow" /></div>
                      </Link>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="recent-row">
            <Link to="/blog" className="default-btn color-btn">
              <span >View All Articles</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
